import React, { useCallback, useEffect, useRef, useState } from "react";
import Banner from "./Banner/Banner";
import Result from "./Banner/Result/Result";
import * as Apis from "../../config/Api";
import { constants } from "../../config/constants";
import "./Home.css";
import Compare from "./Compare/Compare";
import About from "./About/About";
import _ from "underscore";
import { saveAs } from 'file-saver';
import { generateZipFromCloud } from "./Banner/Result/ExportZip";
import Testimonial from "./Testimonials/Testimonials";
import Pricing from "./Pricing/Pricing";
import PriceChart from "./Pricing/PriceChart";
import { Helmet } from "react-helmet";
import Alert from "../Common/Alert";

const limit = 25000000
// const limit = 25000
const Home = () => {
    const myRef = useRef(null)
    const [files, setfiles] = useState([])
    const [compression_count, setcompression_count] = useState(1)
    let compression_limit = 26;
    const [imageFiles, setImageFiles] = useState([])
    const [imageData, setImageData] = useState([])
    const [imageArray, setImageArray] = useState([])
    const [totalPercentage, setTotalPercentage] = useState(0)
    const [enableBtn, setenableBtn] = useState(false)
    const [formats, setFormats] = useState({
        show: false,
        items: {
            png: false,
            jpeg: false,
            avif: false,
            webp: false
        }
    })

    const [alertVal, setalertVal] = useState({
        showAlert: false,
        successAlert: false,
        alertMsg: ""
    })
    const toast = (alertOpen, alertType, msg) => {
        setalertVal({ ...alert, 'showAlert': alertOpen, 'successAlert': alertType, 'alertMsg': msg })
        setTimeout(() => {
            closeAlert()
        }, 3000);
    }
    const closeAlert = () => {
        setalertVal({ ...alert, 'showAlert': false, 'successAlert': false, 'alertMsg': "" })
    }

    let newImageData = []

    const recursiveMethod = (files, index) => {
        console.log("first: ", files, "index: ", index)
        if (index > -1) {
            let format = Object.keys(formats.items)
                .filter(key => formats.items[key])
            let formData = new FormData();
            formData.append('image', files[index]);
            if (format.length &&format.join(",")) {
                formData.append('formats', format.join(","));
            }
            getUploadData(formData, files, index, format)
        }
    }
    function comparer(otherArray) {
        return function (current) {
            return otherArray.filter(function (other) {
                return other.file_name == current.name
            }).length == 0;
        }
    }

    const handleOnDrop = async (file) => {
        if (file) {
            var onlyInA = file.filter(comparer(imageData));
            var onlyInB = imageData.filter(comparer(file));
            let result = onlyInA.concat(onlyInB);
            result.map((data, i) => {
                if (imageData.length < compression_limit && i < compression_limit) {
                    if (data.size > limit) {
                        newImageData.push({ ...data, file_name: data.name, original_size: data.size, oversize: true, success: true, loading: true })
                    } else {
                        newImageData.push({ ...data, file_name: data.name, original_size: data.size, loading: true })
                    }
                } else {
                    newImageData.push({ ...data, file_name: data.name, original_size: data.size, over: true, loading: true })
                }
            })
            if (imageData.length < compression_limit) {
                let newResult = result.filter((opt) => opt.size < limit)
                setImageFiles([...imageFiles, ...newResult])
                recursiveMethod(newResult.slice(0, compression_limit), newResult.slice(0, compression_limit).length - 1);
            }
            setImageArray([...imageArray, ...newImageData])
            setImageData([...imageData, ...newImageData])
        }
    }

    const getUploadData = async (body, files, recIndex, format) => {
        recIndex = recIndex - 1
        recursiveMethod(files, recIndex);
        files.map((data, i) => {
            newImageData[i] = { file_name: data.name, original_size: data.size, loading: true, success: false }
            setImageData([...imageData, ...newImageData.filter((x) => x)])
        })
        // let setProgressBarAvg = 1 / files.length;
        await Apis.PostApiMethod(constants.UPLOAD, body).then(res => {
            console.log("res", res, format)
            if (res.error === true) {
                if (res.res.data && res.res.data.file_name) {
                    let index = _.findIndex(files, function (val) {
                        return val.name == res.res.data.file_name
                    });
                    newImageData[index] = { ...res.data, loading: false }
                    setImageData([...imageData, ...newImageData.filter((x) => x)])
                    setImageArray([...imageData, ...newImageData.filter((x) => x)])
                }
                toast(true, false, res.response.data.error)
            } else {
                let loading = true
                if (format.length && format.length !== res.data.converted_formats.length) {
                    loading = true
                } else {
                    loading = false
                }
                if (res.data && res.data.file_name) {
                    let index = _.findIndex(files, function (val) {
                        return val.name == res.data.file_name
                    });
                    newImageData[index] = { ...res.data, loading: loading }
                    setImageData([...imageData, ...newImageData.filter((x) => x)])
                    setImageArray([...imageData, ...newImageData.filter((x) => x)])
                }
                if (res.data.success) {
                    setcompression_count(compression_count + 1)
                    // let dropbox_files = []
                    // newImageData.map((opt) => {
                    //     dropbox_files.push({ 'url': opt.compress_path, 'filename': opt.file_name })
                    // })
                }
            }
        })
    }
    const download = (opt, name) => {
        saveAs(opt.compress_path, `${opt.compress_path.split("/").pop()}`);
    };

    const downloadAll = () => {
        // let urls = imageData.filter((obj) => obj.success).map((opt) => {
        //     opt.converted_formats
        //     return opt.compress_path
        // })
        const allCompressPaths = imageData.filter((obj) => obj.success).flatMap(item =>
            item.converted_formats && item.converted_formats.length && item.converted_formats.map(format => format.compress_path)
        );
        generateZipFromCloud(allCompressPaths)
    }

    useEffect(() => {
        let format = Object.keys(formats.items)
        .filter(key => formats.items[key])
        
        // if (format.length) {
            const delayDebounceFn = setTimeout(() => {
                imageFiles.map((_opt, index) => {
                    recursiveMethod(imageFiles, index);
                })
            }, 1000);
    
            return () => clearTimeout(delayDebounceFn);
        // }
    },[formats.items])
    
    console.log("imageFiles: ", imageFiles)
    console.log("enableBtn: ", enableBtn)

    useEffect(() => {
        let fileLength = imageData.filter((opt) => opt.success && !opt.loading).length
        let fileArrLength = imageArray.filter((opt) => !opt.over && !opt.loading).length
        console.log("fileArrLength: ", fileArrLength, "fileLength: ", fileLength, imageData, imageArray)
        if (fileArrLength == imageData.length && fileArrLength === fileLength) {
            setenableBtn(true)
        } else {
            setenableBtn(false)
        }

        const allCompressPaths = imageData.filter((obj) => obj.success).flatMap(item =>
            item.converted_formats && item.converted_formats.length && item.converted_formats.map((format) => ({ 'url': format.compress_path, 'filename': `${format.compress_path.split("/").pop()}` }))
        );
        setfiles(allCompressPaths)

        let percentArray = []
        imageData.map((data) => {
            percentArray.push(data.compress_percentage ? parseInt(data.compress_percentage.split("%")[0]) : 0)
        })
        var sum = _.reduce(percentArray, function (memo, num) {
            return memo + num;
        }, 0);
        setTotalPercentage(parseInt(sum / percentArray.length))
    }, [imageData, imageArray])

    const executeScroll = () => {
        myRef.current.scrollIntoView()
    }

    const handleCheck = (e) => {
        if (e.target.name == "show") {
            setFormats({
                ...formats,
                [e.target.name]: e.target.checked
            })
        } else {
            setImageData([])
            setImageArray([])
            setFormats({
                ...formats,
                items: {
                    ...formats.items,
                    [e.target.name]: e.target.checked
                }
            })
        }
    }

    return (
        <>
            <Helmet>
                <title>Compress PNG and JPG files intelligently and instantly</title>
            </Helmet>
            <div className="headerbg">
                <Banner
                    handleOnDrop={handleOnDrop}
                    formats={formats}
                    handleCheck={handleCheck}
                />
            </div>
            <Result
                imageData={imageData}
                totalPercentage={totalPercentage}
                download={download}
                downloadAll={downloadAll}
                enableBtn={enableBtn}
                executeScroll={executeScroll}
                files={files}
            />
            <Compare />
            <About />
            <Testimonial />
            <Pricing ref={myRef} />
            <PriceChart />
            <div className="trustedcompany" >
                <div className="container">
                    <p>PNG Compressor works out of the box for these companies</p>
                    <ul className="navbar-nav nav row trusted_slide ">
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                    </ul>
                </div>
            </div>
            <Alert
                showAlert={alertVal.showAlert}
                successAlert={alertVal.successAlert}
                alertMsg={alertVal.alertMsg}
            />
        </>
    )
}

export default Home